import { getMapaById, MapaListItem } from "@/lib/services/mapas";
import { EventoPublicado, TipoEntrada } from "@/types";
import { createContext, useContext, useState, useEffect, Dispatch, SetStateAction } from "react";

type EventoContextType = {
    evento: EventoPublicado;
    setEvento: Dispatch<SetStateAction<EventoPublicado>>;
    mapa: MapaListItem | null;
    setMapa: Dispatch<SetStateAction<MapaListItem | null>>;
    tipos: TipoEntrada[];
    setTipos: Dispatch<SetStateAction<TipoEntrada[]>>;
}

export const EventoContext = createContext<EventoContextType | null>(null);

export const EventoProvider = ({
    children,
    evento: eventoInicial,
    mapa: mapaInicial,
    tipos: tiposInicial
}: {
    children: React.ReactNode;
    evento: EventoPublicado;
    mapa: MapaListItem | null;
    tipos: TipoEntrada[];
}) => {

    const [evento, setEvento] = useState<EventoPublicado>(eventoInicial);
    const [mapa, setMapa] = useState<MapaListItem | null>(mapaInicial);
    const [tipos, setTipos] = useState<TipoEntrada[]>(tiposInicial);


    return (
        <EventoContext.Provider value={{
            evento,
            setEvento,
            mapa,
            setMapa,
            tipos,
            setTipos
        }} >
            {children}
        </EventoContext.Provider>
    )
}

export const useEventoContext = () => {
    const context = useContext(EventoContext);
    if (!context) {
        throw new Error('useEventoContext must be used within an EventoProvider');
    }
    return context;
}